import { HTMLAttributes } from 'react';

import { cn } from '@components/primitives';

import css from './Dialog.module.css';

export function DialogBody({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn(css.body, className)} {...props}>
      {children}
    </div>
  );
}
